const initialState = () => ({
  folders: [],
  subFolders: [],
  subFolderEdit: null,
  subFolderName: null,
  selectedRol: null,
  selectedFolder: null,
  checkRol: false,
  locationsList: null,
  currentLocations: [],
  status: null
})

export default initialState
